import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers } from "../data/content";
type Buyer = {
  name: string;
  country: string;
  minutesAgo: number;
};
function pickBuyer(prev?: string): Buyer {
  let b = recentBuyers[Math.floor(Math.random() * recentBuyers.length)];
  if (prev && b.name === prev) {
    b = recentBuyers[(recentBuyers.indexOf(b) + 1) % recentBuyers.length];
  }
  return {
    ...b,
    minutesAgo: 1 + Math.floor(Math.random() * 14)
  };
}
export function PurchasePopup() {
  const [buyer, setBuyer] = useState<Buyer | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let lastName: string | undefined;
    const show = () => {
      const next = pickBuyer(lastName);
      lastName = next.name;
      setBuyer(next);
      hideTimer = window.setTimeout(() => setBuyer(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const initials = buyer ? buyer.name.replace(/^Dra?\.\s/, "").split(" ").map(p => p[0]).join("").slice(0, 2) : "";
  return <div className="pointer-events-none fixed inset-x-3 bottom-[88px] z-50 md:inset-x-auto md:bottom-6 md:left-6 md:w-[360px]" aria-live="polite" data-id="element-296" data-mp="n7n2ofnyhtnl">
      <AnimatePresence data-id="element-297" data-mp="x519dnk2v42p">
        {buyer && !dismissed && <motion.div key={buyer.name + buyer.minutesAgo} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-brand-100" data-id="element-298" data-mp="x6m53gi4ot25">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-700 text-sm font-extrabold text-white" data-id="element-299" data-mp="2fmv3oz7h5wu5">
              {initials}
            </span>
            <div className="min-w-0" data-id="element-300" data-mp="2pmdk55o6f0hg">
              <p className="truncate text-sm font-bold text-ink" data-id="element-301" data-mp="2plbvtzi5ghhs">
                {buyer.name} <span className="font-medium text-muted" data-id="element-302" data-mp="1rz4t6v5eoz82">from {buyer.country}</span>
              </p>
              <p className="text-xs text-muted" data-id="element-303" data-mp="1wy7xgddkb1ez">just purchased the Clinical Decision Roadmap™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-emerald-600" data-id="element-304" data-mp="21v84orm5ea7o">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-305" data-mp="26o1738u596gl" />
                Verified purchase · {buyer.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:text-ink" aria-label="Dismiss notification" data-id="element-306" data-mp="1e65cwqxsv0zg">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-307" data-mp="3ig9yyhxp01zk" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}